import React from 'react'
import { loadSettings } from '../../flux/settings/SettingsActions'
import { isLocalStorageAvailable } from '../../repositories/LocalStorageUtilities'

/**
 * Component responsible for loading stored application
 * session settings.
 * e.g. Autosave on / off
 *      Focused on / off
 */
function ControlSettingsLoad() {
    loadSettings(!isLocalStorageAvailable())

    return <></>
}

export { ControlSettingsLoad as default }
